import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const NewsIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g id="News">
          <path
            d="M0,15 C0,23.284 6.716,30 15,30 C23.284,30 30,23.284 30,15 C30,6.716 23.284,0 15,0 C6.716,0 0,6.716 0,15"
            fill="#008CC7"
            id="Fill-1"
          ></path>
          <path
            d="M9.2576,22.0537 C9.2576,22.5647 9.6756,22.9817 10.1856,22.9817 L20.6036,22.9817 C21.1136,22.9817 21.5316,22.5647 21.5316,22.0537 L21.5316,10.7837 C21.5316,10.2737 21.2486,9.5487 20.9026,9.1737 L18.8066,6.9017 C18.4606,6.5257 17.7596,6.2187 17.2496,6.2187 L10.1856,6.2187 C9.6756,6.2187 9.2576,6.6367 9.2576,7.1467 L9.2576,22.0537 Z"
            fill="#ffffff"
            className={styles.white}
            id="Fill-3"
          ></path>
          <polyline
            id="Stroke-5"
            points="18.1775 6.2189 18.1775 9.8659 21.5315 9.8559"
            stroke="#008CC7"
            strokeLinejoin="round"
            strokeWidth="0.5"
          ></polyline>
          <line
            id="Stroke-7"
            stroke="#008CC7"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.5873"
            x2="18.6623"
            y1="12.2067"
            y2="12.2067"
          ></line>
          <line
            id="Stroke-9"
            stroke="#008CC7"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.5873"
            x2="18.6623"
            y1="15.6498"
            y2="15.6498"
          ></line>
          <line
            id="Stroke-11"
            stroke="#008CC7"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.5873"
            x2="18.6623"
            y1="13.9228"
            y2="13.9228"
          ></line>
          <line
            id="Stroke-13"
            stroke="#008CC7"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.5873"
            x2="18.6623"
            y1="19.2968"
            y2="19.2968"
          ></line>
          <line
            id="Stroke-15"
            stroke="#008CC7"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.5873"
            x2="18.6623"
            y1="17.5698"
            y2="17.5698"
          ></line>
        </g>
      </g>
    </Icon>
  )
}
